<template>
  <div class="my-pages">
    HERE123 REMOVE
    <div class="my-pages__content-grid invoice-history__top-grid">
      <div class="input-column">
        <div>
          <h2 v-epi-edit="'InvoiceHistoryHeader'" class="my-pages__page-type-header">
            {{ t('invoiceHistoryHeader') }}
          </h2>
        </div>
      </div>
    </div>

    <div class="invoice-history__filter-grid">
      <!-- Sök o lägg till artiklar -->
      <oie-base-input
        id="invoice-history-search-invoice"
        v-model="searchPhrase"
        :label-text="t('searchPhraseDescription')"
        epi-edit="'SearchPhraseDescription'"
        :placeholder="t('searchPhrasePlaceholder')"
        class="invoice-history__search-input"></oie-base-input>

      <div class="input invoice-history__date-inputs">
        <label v-epi-edit="'FromDateHeader'" for="invoice-history-search-date-from" class="input__label">{{ t('fromDateHeader') }}</label>

        <div class="input__container">
          <datepicker
            ref="fromDate"
            v-model="fromDate"
            :placeholder="t('fromDatePlaceholder')"
            :monday-first="true"
            wrapper-class="datepicker"
            calendar-class="datepicker-calendar"
            input-class="datepicker-input"
            format="yyyy-MM-dd"
            :language="languages[0]"
            :full-month-name="true"></datepicker>
        </div>
      </div>

      <div class="input invoice-history__date-inputs">
        <label v-epi-edit="'ToDateHeader'" for="invoice-history-search-date-from" class="input__label">{{ t('toDateHeader') }}</label>

        <div class="input__container">
          <datepicker
            v-model="toDate"
            :placeholder="t('toDatePlaceHolder')"
            :monday-first="true"
            wrapper-class="datepicker"
            calendar-class="datepicker-calendar"
            input-class="datepicker-input"
            format="yyyy-MM-dd"
            :language="languages[0]"
            :full-month-name="true"></datepicker>
        </div>
      </div>
    </div>

    <div class="invoice-history__filter-actions">
      <oie-base-checkbox
        v-model="openInvoices"
        is-for="invoice-history-search-open-invoices"
        :text="t('searchOpenInvoices')"
        size="large"
        css-classes="sign-in-box__checkbox"></oie-base-checkbox>

      <oie-base-button css-classes="button--with-border button--blue invoice-history__date-search" text="Sök" @click="search"></oie-base-button>
    </div>

    <section>
      <h3 v-epi-edit="'InvoiceListHeader'" class="invoice-history__column-header">
        {{ t('invoiceListHeader') }}
        <!-- Invoicelista -->
      </h3>
      <!-- <div class="invoice-history__description-text">
        [antal] invoices matchar: [datum]
      </div> -->
      <oie-invoice-history-table v-element-loader="{ endpoint: 'invoice/search' }" :invoices="invoices"></oie-invoice-history-table>
    </section>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker/dist/vuejs-datepicker.esm.js'
import { sv, de, sr } from 'vuejs-datepicker/dist/locale'
import httpService from '@/core/http-service'

export default {
  components: {
    Datepicker
  },
  data: () => ({
    languages: [sv, de, sr],
    fromDate: undefined,
    toDate: undefined,
    searchPhrase: '',
    openInvoices: false,
    invoices: [],
    moreToGet: false
  }),
  mounted() {
    this.toDate = new Date()
    this.fromDate = new Date()
    this.fromDate.setFullYear(this.fromDate.getFullYear() - 1)
    this.search()
  },
  methods: {
    search() {
      httpService.post('invoice/search', { fromDate: this.fromDate, toDate: this.toDate, searchPhrase: this.searchPhrase, openInvoices: this.openInvoices }).then((response) => {
        this.invoices = response.data.invoices
        this.moreToGet = response.data.moreToGet
      })
    },
    test() {
    }
  }
}
</script>

<style lang="scss">
  .invoice-history__top-grid {
    margin-bottom: measure(full);

    @include media(medium) {
      margin-bottom: measure(double);
    }
  }

  .invoice-history__filter-grid {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: measure(half);

    @include media(medium) {
      margin-bottom: measure(full);
      justify-content: space-between;
    }

    @include media(medium) {
      flex-wrap: nowrap;
    }
  }

  .invoice-history__filter-grid > * {
    margin-bottom: measure(half);

    &:last-child {
      margin-bottom: 0;
    }

    @include media(small) {
      margin-bottom: 0;

      &:first-child {
        margin-bottom: measure(half);
      }
    }

    @include media(medium) {
      &:first-child {
        margin-bottom: 0;
      }
    }
  }

  .invoice-history__search-input {
    flex-basis: 100%;

    @include media(medium) {
      flex-basis: 31.25rem;
      flex-shrink: 0;
      margin-right: measure(full);
    }
  }

  .invoice-history__date-inputs {
    flex-basis: 100%;
    flex-grow: 1;

    @include media(small) {
      flex-basis: 47%;

      &:nth-child(2) {
        margin-right: measure(full);
      }
    }

    @include media(medium) {
      flex-basis: auto;
    }
  }

  .invoice-history__column-header {
    @include h2-semi-bold;
    margin-top: 0;
    margin-bottom: measure(eighth) !important;
  }

  .my-pages__page-type-header {
    margin-bottom: measure(half);
  }

  .invoice-history__description-text {
    @include body;
    margin-bottom: measure(quarter) !important;
  }

  .input-column.invoice-history__column {
    max-width: 100%;
  }

  .invoice-history__date-filter {
    display: flex;
    flex-direction: column;

    @include media(medium) {
      flex-direction: row;
    }
  }

  .invoice-history__date-input-container {
    flex-grow: 1;

    @include media(to-small) {
      &:not(:last-child) {
        margin-bottom: measure(half);
      }
    }

    @include media(medium) {
      &:first-child {
        margin-right: measure(quarter);
      }
    }
  }

  .invoice-history__filter-actions {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    margin-bottom: measure(full);

    @include media(small) {
      flex-direction: row;
    }
  }

  .invoice-history__filter-actions > * {
    @include media(to-small) {
      &:first-child {
        margin-bottom: measure(half);
      }
    }
  }

  .invoice-history__date-search {
    width: 100%;

    @include media(small) {
      flex-basis: 9.375rem;
      width: auto;
      margin-left: measure(full);
    }

    @include media(medium) {
      align-self: flex-end;
    }
  }
</style>
